import React, { useEffect, useState } from 'react'
import propTypes from 'prop-types'
import { Translate } from 'react-localize-redux'
import { components } from 'react-select'
import moment from 'moment'
import Select from 'react-select'

/** Material UI import section */
import { withStyles } from '@material-ui/core/styles'
import { Grid, Paper, Typography, Toolbar, TextField } from '@material-ui/core'
import TimeIcon from '@material-ui/icons/Schedule'

/** Custom components import section */
import Dialog from '../../common/Dialog'
import DialogActions from '../../common/DialogActions'
import DatePicker from '../../common/DateTimePicker/DatePicker'
import WarningComponent from '../../common/WarningComponent'
import VehicleSelect from './VehicleSelect'
import Toaster from '../../common/Toaster'

/** Redux import section*/
import { useDispatch, useSelector } from 'react-redux'
import { loadVehicles, setToasterOptions } from '../../../store/controlCO2/controlCO2Action'
import { getVehiclesSelector } from '../../../store/controlCO2/controlCO2Selectors'
/** Resources import section */
import { SHOW_EDIT_VIEW } from '../../../store/helpers/ResourcesHelper'
import { GetArrivalCO2Hours } from '../../../store/helpers/SelectOptions'
import chroma from 'chroma-js'

const buildVehicleOption = (vehicle) => ({ value: vehicle.token, label: `${vehicle.economicNumber}` })

const AddControlModal = (props) => {
	const { open, onClose, onAddRequest, isBlocked } = props
	const toasterConfiguration = useSelector((state) => state.controlCO2.get('toasterConfiguration').toJS())
	const isSaving = useSelector((state) => state.controlCO2.get('isSaving'))
	const [control, setcontrol] = useState({
		destination: '',
		carbonResult: '',
		checkOutDate: moment().format('L'),
		checkInDate: moment().format('L'),
		vehicleToken: '',
		checkInTime: { value: '', label: '' },
		checkOutTime: { value: '', label: '' },
	})

	/** Connect with redux */
	const dispatch = useDispatch()
	const allVehicles = useSelector((state) => getVehiclesSelector(state))
	const vehicleOptions = allVehicles.map((vehicle) => buildVehicleOption(vehicle))

	/** Load vehicles data */
	useEffect(() => {
		dispatch(loadVehicles())
	}, [dispatch])

	const updateProperty = (property, value) => {
		let controlUpdate = { ...control }
		controlUpdate[property] = value
		if (property === 'km') controlUpdate['carbonResult'] = 0
		if (property === 'checkOutTime') {
			var day = moment(control.checkOutDate, 'DD/MM/YYYY')
			var splitTime = value.label.split(/:/)
			day.hours(parseInt(splitTime[0])).minutes(parseInt(splitTime[1])).seconds(0).milliseconds(0)
			controlUpdate['checkOutDate'] = day
			controlUpdate['checkOutTime'] = value
		}
		if (property === 'checkInTime') {
			var dayIn = moment(control.checkInDate, 'DD/MM/YYYY')
			var splitTimeIn = value.label.split(/:/)
			dayIn.hours(parseInt(splitTimeIn[0])).minutes(parseInt(splitTimeIn[1])).seconds(0).milliseconds(0)
			controlUpdate['checkInDate'] = dayIn
			controlUpdate['checkInTime'] = value
		}
		if (property === 'checkOutDate' || property === 'checkInDate') {
			controlUpdate['checkInTime'] = {}
			controlUpdate['checkOutTime'] = {}
		}
		setcontrol(controlUpdate)
	}

	const onAddRequestControl = () => {
		onAddRequest(control).then(() => {
			onClose()
			setcontrol({
				destination: '',
				carbonResult: '',
				cleaningCheck: '',
				observations: '',
				checkOutDate: moment().format('L'),
				checkInDate: moment().format('L'),
				vehicleToken: '',
				checkOutTime: { value: '', label: '' },
				checkInTime: { value: '', label: '' },
			})
		})
	}

	const canBeSaved = () => {
		if (isSaving || isBlocked) return false
		else {
			if (control.destination.length === 0) return false
		}
		return true
	}

	const renderSelect = (model, key, property) => {
		let arrivalHoursCO2 = GetArrivalCO2Hours([])
		return (
			<Select
				value={model}
				options={arrivalHoursCO2}
				onChange={(selectedOption) => updateProperty(key, selectedOption)}
				styles={colouredOptions}
				components={{ DropdownIndicator }}
				menuPortalTarget={document.body}
				menuPosition='fixed'
				menuPlacement={'auto'}
			/>
		)
	}

	return (
		<Paper style={{ overflowX: 'hidden' }}>
			<Dialog
				style={{ overflowX: 'hidden' }}
				open={open}
				onClose={onClose}
				header={
					<Toolbar>
						<Typography variant='h6'>{<Translate id='controlCO2.addControl' />}</Typography>
					</Toolbar>
				}
				actions={
					<DialogActions
						view={SHOW_EDIT_VIEW}
						onCancel={onClose}
						onClose={onClose}
						onSaveItem={() => onAddRequestControl()}
						isSaving={isSaving}
						canBeSaved={canBeSaved()}
					/>
				}
			>
				{isBlocked && (
					<Grid container style={{ width: 500 }} justify='space-between'>
						<WarningComponent message={<Translate id='controlCO2.blockMessage' />} />
					</Grid>
				)}
				{!isBlocked && (
					<Grid container style={{ width: 500 }} justify='space-between'>
						<Grid item xs={12}>
							<Typography style={{ marginLeft: '6px' }} variant='caption' color={'textSecondary'}>
								{<Translate id='controlCO2.vehicle' />}
							</Typography>
							<VehicleSelect
								options={vehicleOptions}
								onOptionChange={(selectedOption) => {
									updateProperty('vehicleToken', selectedOption.value)
								}}
							/>
						</Grid>
						<Grid item xs={12}>
							<Typography style={{ marginLeft: '6px' }} variant='caption' color={'textSecondary'}>
								{<Translate id='controlCO2.destinationPlace' />}
							</Typography>
							<TextField
								fullWidth
								id='outlined-size-small'
								label={''}
								defaultValue={control.destination}
								onChange={(event) => {
									updateProperty('destination', event.target.value)
								}}
								variant='outlined'
							/>
						</Grid>
						<Grid item xs={6}>
							<Typography style={{ marginLeft: '6px' }} variant='caption' color={'textSecondary'}>
								Fecha y Hora de salida
							</Typography>
							<DatePicker
								onChangeRange={(event) => updateProperty('checkOutDate', event)}
								minDate={moment()}
								startDate={control.checkOutDate ? moment(control.checkOutDate, 'DD/MM/YYYY') : ''}
							/>
						</Grid>
						<Grid item xs={1}></Grid>
						<Grid item xs={5}>
							<div style={{ marginTop: '20px' }}>
								{renderSelect(control.checkOutTime, 'checkOutTime', 'checkOutTime')}
							</div>
						</Grid>
						<Grid item xs={6}>
							<Typography style={{ marginLeft: '6px' }} variant='caption' color={'textSecondary'}>
								Fecha y Hora de entrega
							</Typography>
							<DatePicker
								onChangeRange={(event) => updateProperty('checkInDate', event)}
								minDate={moment()}
								startDate={control.checkInDate ? moment(control.checkInDate, 'DD/MM/YYYY') : ''}
							/>
						</Grid>
						<Grid item xs={1}></Grid>
						<Grid item xs={5}>
							<div style={{ marginTop: '20px' }}>
								{renderSelect(control.checkInTime, 'checkInTime', 'checkInTime')}
							</div>
						</Grid>
					</Grid>
				)}
			</Dialog>
			<Toaster
				message={<Translate id={toasterConfiguration.toasterMessage} />}
				open={toasterConfiguration.showToaster}
				variant={toasterConfiguration.toasterVariant}
				onClose={() => {
					dispatch(
						setToasterOptions({
							showToaster: false,
							toasterVariant: '',
							toasterMessage: '',
						})
					)
				}}
			/>
		</Paper>
	)
}

const colouredOptions = {
	control: (styles) => ({ ...styles, backgroundColor: 'white' }),
	option: (styles, { data, isDisabled, isFocused, isSelected }) => {
		const color = chroma(data.color ? data.color : 'white')
		return {
			...styles,
			backgroundColor: isFocused ? (data.color ? color.alpha(0.5).css() : '#eaeaea') : data.color,
			color: chroma.contrast(color, 'white') > 2 ? 'white' : 'black',
			cursor: isDisabled ? 'not-allowed' : 'default',
			':active': {
				...styles[':active'],
				backgroundColor: !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
			},
		}
	},
	indicatorSeparator: () => null,
	menu: (base) => ({ ...base, zIndex: 62, maxHeight: 150 }),
	menuList: (base) => ({ ...base, maxHeight: 150, paddingTop: 0 }),
	menuPortal: (base) => ({ ...base, zIndex: 9999 }), /// THIS IS TO SHOW MENU OVER MODAL
	indicatorContainer: (base) => ({ ...base, maxWidth: 28, padding: 0 }),
	dropdownIndicator: (styles) => ({ ...styles, backgroundColor: 'rgba(191, 12, 61,1)', color: 'white' }),
}
const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<TimeIcon style={{ color: 'white' }} />
		</components.DropdownIndicator>
	)
}
const dialogStyles = (theme) => ({
	textField: {
		'&.MuiInputBase-root': {
			padding: '10px 14px',
		},
	},
})

AddControlModal.propTypes = {
	open: propTypes.bool,
	onClose: propTypes.func,
	onAddRequest: propTypes.func,
	isBlocked: propTypes.func,
}

AddControlModal.defaultProps = {
	open: false,
	onClose: () => console.warn('Callback [onClose] no defined'),
	onAddRequest: () => console.warn('Callback [onAddRequest] no defined'),
	isBlocked: () => console.warn('Callback [isBlocked] no defined'),
}

export default withStyles(dialogStyles, { withTheme: true })(AddControlModal)
